import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import Dropdown from 'component-dropdown';

import VariantCarouselSlidePicker from "./VariantCarouselSlidePicker";
import CarouselSlidePicker from "./CarouselSlidePicker";
import PackagePicker from "./PackagePicker";
import VehicleSpecs from "./VehicleSpecs";
import ConfirmationPopup from "./ConfirmationPopup";
import currencyHelper from '../../helpers/CurrencyHelper';
import ICON_ARROW_NEXT from './arrow-next.png';
import Defaulf_Img from './vehicleimagenotavailable1.png';
import Down_Arrow from './down-arrow.png';
import { Field, reduxForm } from 'redux-form'
import validationHelper from "../../helpers/ValidationHelper";
import { apiSubmitApplicationNew, apiGetLoanMaster, apiFetchCarModelDetailsNew, apiGetShowroomList } from "../../apis/calculator";
import { withRouter } from "react-router";
import ReCAPTCHA from "react-google-recaptcha";
import arrow from './arrow.svg';

import ICON_BACK from '../../shared/images/back.png'
import ReactPixel from 'react-facebook-pixel';

const options = [""]

class CustomerInfo extends Component {
    constructor() {
        super();
        this.state = {
            showPopup: false,
            yearvalue1: '',
            monthvalue: '',
            myDate: '',
            myOption: 'wyne',

            consent: false,
            popupTxt: '',

            firstNameError: false,
            lastNameError: false,
            mobileError: false,
            emailError: false,
            showroomError: false,

            firstNameErrorMsg: '',
            lastNameErrorMsg: '',
            mobileErrorMsg: '',
            emailErrorMsg: '',
            showroomErrorMsg: '',

            formMode: false,
            loanMaster: {},


            promoCodeId: '',
            promoCode: '',
            nettPrice: '',
            tenure: '',
            loanAmount: '',
            monthlyPayment: '',
            interestRate: '',
            techSpec1: '',
            techSpec2: '',
            techSpec3: '',
            techSpec4: '',
            colorPaletteCode: '',
            colorName: '',
            stock: '',
            pdf: '',
            src: '',
            modelClassLabel: '',
            carModelName: '',

            salutation: '',
            firstName: '',
            lastName: '',
            mobile: '',
            email: '',
            showroom: '',
            showroomList: [],
            id: '',

            showPopup2: false,
            showPopup3: false,

            remarks: '',
            loanPercent: '',
            prod: false

        };
    }

    componentDidMount = () => {

        if (window.location.href.includes("online-sales.mazda.com.sg")) {
            ReactPixel.init('273792070524054');
            ReactPixel.pageView();

            this.setState({
                prod: true
            })
          }

        if (localStorage.getItem('data')) {
            const data = JSON.parse(localStorage.getItem('data'));

            this.setState({
                promoCodeId: data.promoCodeId,
                promoCode: data.promoCode,
                nettPrice: data.netPrice,
                tenure: data.tenure,
                loanAmount: data.loanAmount,
                monthlyPayment: data.monthlyPayment,
                interestRate: data.interestRate,
                techSpec1: data.techSpec1,
                techSpec2: data.techSpec2,
                techSpec3: data.techSpec3,
                techSpec4: data.techSpec4,
                colorPaletteCode: data.colorPaletteCode,
                colorName: data.colorName,
                stock: data.stock,
                pdf: data.pdf,
                src: data.src,
                modelClassLabel: data.modelClassLabel,
                carModelName: data.carModelName,
                id: data.id,
                omvLoanPercent: data.omvLoanPercent,
                loanPercent: data.loanPercent
            })

            apiGetShowroomList().then((res) => {
                if (res) {
                    this.setState({
                        showroomList: res
                    })
                }
            }).catch((e) => {
                this.setState({
                    showPopup: true,
                    popupTxt: 'An error has been encountered. Please retry later.'
                })
                console.log(e)
            });
        }
        else {
            this.props.history.push('/');
        }


    }

    onCaptchaExpire = () => {
        this.setState({
            captcha: false
        })
    }
  
    onCaptchaComplete = () => {
        this.setState({
            captcha: true
        })
    }

    handleCheck = () => {
        const val = this.state.consent;
        this.setState({
            consent: !val
        })
    }

    handlePopup = () => {
        const val = this.state.showPopup;
        this.setState({
            showPopup: !val
        })
    }

    handlePopup2 = () => {
        const val = this.state.showPopup2;
        this.setState({
            showPopup2: !val
        }, () => {
            let params = this.props.match.params; 

            let data = {
                variantId: params.variantId,
                isNew: params.isNew
            }

            let context = {
                companyId: 1000,
                zoneId: 10
            }

            apiFetchCarModelDetailsNew(data, context).then((res) => {
                if (res && res.carModelDetailList && res.carModelDetailList.length) {
                    this.props.history.push('/calculator/' + params.variantId + "/" + params.isNew + "/" + params.carModelId + "/" + params.color + "/" + params.loanPercent + "/" + params.tenure )
                }
                else {
                    this.props.history.push('/')
                }
            }).catch((e) => {
                this.setState({
                    showPopup: true,
                    popupTxt: 'An error has been encountered. Please retry later.'
                })
                console.log(e)
            });


        })
    }

    handlePopup3 = () => {
        const val = this.state.showPopup3;
        this.setState({
            showPopup3: !val
        }, () => {
            let params = this.props.match.params; 

            let data = {
                variantId: params.variantId,
                isNew: params.isNew
            }

            let context = {
                companyId: 1000,
                zoneId: 10
            }

            apiFetchCarModelDetailsNew(data, context).then((res) => {
                if (res && res.carModelDetailList && res.carModelDetailList.length) {
                    this.props.history.push('/calculator/' + params.variantId + "/" + params.isNew + "/" + params.carModelId + "/" + params.color + "/" + params.loanPercent + "/" + params.tenure )
                }
                else {
                    this.props.history.push('/')
                }
            }).catch((e) => {
                this.setState({
                    showPopup: true,
                    popupTxt: 'An error has been encountered. Please retry later.'
                })
                console.log(e)
            });

        })
    }

    handleClick = (e, pdf) => {
        e.preventDefault();
        window.open(pdf)
    }

    handleForm = async () => {
        const state = this.state;

        let remarks = this.state.remarks;

        if (remarks) {
            remarks = remarks.replace(/(?:\r\n|\r|\n)/g, '\\n')
        }

        const param = {
            id: state.id,
            name: state.firstName,
            email: state.email,
            mobile: state.mobile,
            salutation: state.salutation,
            lastName: state.lastName,
            preferredShowroom: state.showroom,
            promoCodeId: state.promoCodeId,
            promoCode: state.promoCode,
            nettPrice: state.nettPrice,
            tenure: state.tenure,
            loanAmount: state.loanAmount,
            monthlyPayment: state.monthlyPayment,
            interestRate: state.interestRate,
            customerRemark: remarks,
            omvLoanPercent: state.loanPercent
        }

        apiSubmitApplicationNew(param).then(async(r) => {
            let res = await r.json();
                if (res.data === 1) {
                    this.props.history.push(`/payment/${res.msg}`);
                }
                else if (res.data === 2) {
                    this.setState({
                        showPopup2: true
                    })
                }
                else if (res.data === 3) {
                    this.setState({
                        showPopup3: true
                    })
                }
                else {
                    this.setState({
                        showPopup: true,
                        popupTxt: 'An error has been encountered. Please retry later.'
                    })
                }
        }).catch((e) => {
            this.setState({
                showPopup: true,
                popupTxt: 'An error has been encountered. Please retry later.'
            })
            console.log(e)
        });
    }

    handleChange = (e) => {
        let name = e.target.name,
            val = e.target.value

        if (name === "mobile" && val) {
            if (isNaN(Number(val))) {
                return
            }
        }
        this.setState({
            [name]: val
        }, () => {
            if (name === "firstName") {
                if (!val) {
                    this.setState({
                        firstNameError: true,
                        firstNameErrorMsg: 'Please provide your first name'
                    })
                }
                else if (val.length > 0 && val.length < 3) {
                    this.setState({
                        firstNameError: true,
                        firstNameErrorMsg: 'Please enter more than 2 characters'
                    })
                }
                else {
                    this.setState({
                        firstNameError: false,
                        firstNameErrorMsg: ''
                    })
                }
            }
            if (name === "lastName") {
                if (!val) {
                    this.setState({
                        lastNameError: true,
                        lastNameErrorMsg: 'Please provide your last name'
                    })
                }
                else if (val.length > 0 && val.length < 2) {
                    this.setState({
                        lastNameError: true,
                        lastNameErrorMsg: 'Please enter more than 1 character'
                    })
                }
                else {
                    this.setState({
                        lastNameError: false,
                        lastNameErrorMsg: ''
                    })
                }
            }
            if (name === "mobile") {
                let firstWord = val.slice(0, 1);
                if (!val) {
                    this.setState({
                        mobileError: true,
                        mobileErrorMsg: 'Please provide your phone number'
                    })
                }
                else if (/^(?:[+\d].*\d|\d)$/.test(val) === false) {
                    this.setState({
                        mobileError: true,
                        mobileErrorMsg: 'Please provide a valid phone number'
                    })
                }
                else if (firstWord != '8' && firstWord != '9') {
                    this.setState({
                        mobileError: true,
                        mobileErrorMsg: 'Please provide a valid phone number'
                    })
                }
                else if (val.length !== 8) {
                    this.setState({
                        mobileError: true,
                        mobileErrorMsg: 'Please provide a valid phone number'
                    })
                }
                else {
                    this.setState({
                        mobileError: false,
                        mobileErrorMsg: ''
                    })
                }
            }
            if (name === "email") {
                if (!val) {
                    this.setState({
                        emailError: true,
                        emailErrorMsg: 'Please provide your email address'
                    })
                }
                else if (/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(val) === false) {
                    this.setState({
                        emailError: true,
                        emailErrorMsg: 'Please provide a valid email address'
                    })
                }
                else {
                    this.setState({
                        emailError: false,
                        emailErrorMsg: ''
                    })
                }
            }
            if (name === "showroom") {
                if (!val) {
                    this.setState({
                        showroomError: true,
                        showroomErrorMsg: 'Please select your preferred showroom'
                    })
                }
                else {
                    this.setState({
                        showroomError: false,
                        showroomErrorMsg: ''
                    })
                }
            }
        })
    }


    render() {
        const { className } = this.props;
        const state = this.state;

        const fields = [
            {
                label: 'FUEL CONSUMPTION',
                value: state.techSpec1
            },
            {
                label: 'CO2 EMISSION',
                value: state.techSpec2
            },
            {
                label: 'VES BANDING',
                value: state.techSpec3
            },
            {
                label: 'COE CATEGORY',
                value: state.techSpec4
            }
        ]


        return <div className={className}>
            <div className='wrapper'>
                {
                    this.state.prod ? <img border="0" style={{width: 0, height: 0, position: "absolute"}} src="https://r.turn.com/r/beacon?b2=r6nwVEPY6O9IClFqBC_0pOBCxAlJY_6z9MudjCtJBhKzNPlUFo4chDo95bs8J6m4NApvbKG2lFz-VFEjTPsnrg&cid=" /> : ''
                }
                <div className="nav-container">
                    <div className="nav-wrap">
                        <div className="nav-no">1</div>
                        <div className="nav-txt">Financial calculator</div>
                    </div>
                    <div className="nav-wrap active">
                        <div className="nav-no">2</div>
                        <div className="nav-txt">Customer Information</div>
                    </div>
                    <div className="nav-wrap">
                        <div className="nav-no">3</div>
                        <div className="nav-txt">Payment</div>
                    </div>
                </div>

                <div className="leftSide">
                    <div className='topArtical'>


                        <div className="carTitle-wrap">
                            <span className="carTitle-class">{state.modelClassLabel}</span> <span className="carTitle-label">{state.carModelName}</span> <br />
                            {
                            this.props.match.params.isNew === "false" ?
                            <div className="carTitle-demo">Demo unit</div> : ''
                            }
                        </div>


                        <img className={'configurator__model_image'} src={state.src} alt="" />
                        <div className="carImg-info">Car image is for illustration purpose only. Specifications may vary.</div>

                        <div className="carPrice-wrap">
                                <div className={"colorSwatch c-"+ state.colorPaletteCode.replace('#', '')}>
                                <span className="colorSwatch-checkmark"></span>
                                <div className="colorSwatch-color" style={{ backgroundColor: state.colorPaletteCode }}></div>
                            </div>
                            <span className="carPrice-color">{state.colorName} <span className="carPrice-stock">({state.stock} in stock)</span></span>
                        </div>


                    </div>
                    <div className='cardetailArtical'>
                        <div className="carInfo-title">TECHNICAL DATA</div>
                        <VehicleSpecs fields={fields} />
                        <p className="optinNoticeLink" onClick={(e) => this.handleClick(e, state.pdf)}>
                            Please click here for detailed specifications.
                        </p>
                    </div>
                </div>
                <div id="right-info" className="rightSide">
                    <div className='cardetailArtical rightFullScreen'>
                        <div className="calc-container">
                            <div className="calc-title">Enter your personal details</div>
                            <div className="calc-wrap">
                                <div className="calc-label">Salutation</div>
                                <select value={this.state.salutation} className="calc-select" onChange={this.handleChange} name="salutation">
                                    <option value="">None</option>
                                    <option value={'Ms.'}>Ms.</option>
                                    <option value={'Mdm.'}>Mdm.</option>
                                    <option value={'Prof.'}>Prof.</option>
                                    <option value={'Dr.'}>Dr.</option>
                                    <option value={'Mrs.'}>Mrs.</option>
                                    <option value={'Mr.'}>Mr.</option>
                                </select>
                            </div>
                            <div className="calc-wrap">
                                <div className="calc-label">First Name</div>
                                <input className="calc-input" onChange={this.handleChange} name="firstName" value={this.state.firstName} />
                            </div>
                            {
                                this.state.firstNameError ? 
                                <div className="calc-error">
                                    {this.state.firstNameErrorMsg}
                                </div> : ''
                            }
                            <div className="calc-wrap">
                                <div className="calc-label">Last Name</div>
                                <input className="calc-input" onChange={this.handleChange} name="lastName" value={this.state.lastName} />
                            </div>
                            {
                                this.state.lastNameError ? 
                                <div className="calc-error">
                                    {this.state.lastNameErrorMsg}
                                </div> : ''
                            }
                            <div className="calc-wrap">
                                <div className="calc-label">Email</div>
                                <input className="calc-input" onChange={this.handleChange} name="email" value={this.state.email} />
                            </div>
                            {
                                this.state.emailError ? 
                                <div className="calc-error">
                                    {this.state.emailErrorMsg}
                                </div> : ''
                            }
                            <div className="calc-wrap">
                                <div className="calc-label">Mobile No.</div>
                                <input className="calc-input" onChange={this.handleChange} maxLength="8" name="mobile" value={this.state.mobile} />
                            </div>
                            {
                                this.state.mobileError ? 
                                <div className="calc-error">
                                    {this.state.mobileErrorMsg}
                                </div> : ''
                            }
                            <div className="calc-wrap">
                                <div className="calc-label">Preferred Showroom</div>
                                <select value={this.state.showroom} className="calc-select" onChange={this.handleChange} name="showroom">
                                    <option value=""> </option>
                                    {
                                        state.showroomList.map((i, idx) => <option key={idx} value={i.name}>{i.name}</option>)
                                    }
                                </select>
                            </div>
                            {
                                this.state.showroomError ? 
                                <div className="calc-error">
                                    {this.state.showroomErrorMsg}
                                </div> : ''
                            }
                        </div>
                        <div className="pdpa-wrap">
                            <div className="pdpa-title">PDPA Declaration</div>
                                <label className="consent-check-container">
                                    <input type="checkbox" value={this.state.consent} checked={this.state.consent} onChange={this.handleCheck} />
                                    <span className="consent-checkmark"></span>
                                </label>
                                <div className="consent-txt">I have read and consent to the collection, use and/or disclosure of personal data by Eurokars Group in accordance with the <a href="https://www.mazda.com.sg/legal" target="_blank" className="consent-link"> Data Protection Policy</a>. </div>
                            {
                                !this.state.consent ?
                                    <div className="carInfo-error consent">
                                        Please tick on the checkbox of the consent form in order to submit.
                                </div> : <div className="carInfo-error-placeholder"></div>
                            }
                            <div className="carInfo-error-placeholder"></div>
                        </div>


                        <div className="form-remarks-wrap">
                            <div className="form-remarks-label">Remarks</div>
                            <textarea placeholder={"If you want a valuation for your used car, please provide the following details: \n- Last 4 characters of NRIC \n- Vehicle Registration Number \n- Estimated Mileage"} value={this.state.remarks} onChange={this.handleChange} className="form-remarks-input" name="remarks"></textarea>
                        </div>
                        <div className="form-captcha">
                            <ReCAPTCHA
                                sitekey="6LfOW_wUAAAAAAs8HgNfae2PyqWJrgwnNfJyJ6xd"
                                onChange={this.onCaptchaComplete}
                                onExpired={this.onCaptchaExpire}
                            />
                        </div>


                    <div className="btnWrap">
                        <button 
                            className="carInfo-buy" 
                            onClick={
                                !this.state.captcha || 
                                !this.state.consent || 
                                this.state.mobileError || 
                                this.state.emailError || 
                                this.state.firstNameError || 
                                this.state.lastNameError ||
                                !this.state.showroom
                                ? null : () => this.handleForm()} 
                            disabled={
                                !this.state.consent 
                                || this.state.mobileError || 
                                this.state.emailError || 
                                this.state.firstNameError || 
                                this.state.lastNameError || 
                                !this.state.captcha || 
                                !this.state.firstName || 
                                !this.state.lastName || 
                                !this.state.mobile || 
                                !this.state.email ||
                                !this.state.showroom
                            }
                        >
                            Next
                        </button>
                    </div>
                    </div>
                </div>

            </div>
            {this.state.showPopup ?
                <ConfirmationPopup
                    text={<div className="confirmTxt">
                        <p> {this.state.popupTxt}</p>
                        <button onClick={this.handlePopup} className="btn btn-primary popbtn"> OK </button>

                    </div>}
                // closePopup={this.togglePopup.bind(this)}
                />
                : null
            }
            {this.state.showPopup2 ?
                <ConfirmationPopup
                    text={<div className="confirmTxt">
                        <p> This vehicle is out of stock. Please choose another vehicle.</p>
                        <button onClick={this.handlePopup2} className="btn btn-primary popbtn"> OK </button>

                    </div>}
                // closePopup={this.togglePopup.bind(this)}
                />
                : null
            }
            {this.state.showPopup3 ?
                <ConfirmationPopup
                    text={<div className="confirmTxt">
                        <p> Promotion code is no longer valid. Please submit if you are still interested</p>
                        <button onClick={this.handlePopup3} className="btn btn-primary popbtn"> OK </button>
                    </div>}
                // closePopup={this.togglePopup.bind(this)}
                />
                : null
            }
        </div>
    }
}

let StyledCustomerInfo = styled(CustomerInfo)`
position: relative;
width: 100%;
display: block;
overflow: hidden;

.calc-container, .pdpa-wrap {
    @media (max-width: 420px) {
        padding-left: 15px;
        padding-right: 15px;
    }
}
.calc-title {
    font-weight: bold;
    letter-spacing: 3.45px;
    margin-bottom: 20px;
    text-align: center;
    font-size: 23px;
    text-transform: uppercase;
}
.form-captcha {
    margin-bottom: 20px;

    @media (max-width: 420px) {
        margin-left: 15px;
    }
}

.calc-error {
    margin-bottom: 5px;
    color: #890000;
}

.pdpa-title {
    font-weight: bold;
    font-size: 15px;
    letter-spacing: 2.25px;
    margin-top: 20px;
    margin-bottom: 14px;
}

.form-remarks-label {
    letter-spacing: 2.25px;
    font-size: 15px;
    font-weight: bold;
    text-transform: uppercase;
    color: #101010;
    margin-bottom: 10px;
    margin-top: 20px;
}

.form-remarks-wrap {
    @media (max-width: 420px) {
        padding-left: 15px;
        padding-right: 15px;
    }
}

.form-remarks-input {
    appearance: none;
    border: 0;
    outline: 0;
    color: #890000;

    box-sizing: border-box;
    padding: 15px;
    -webkit-appearance: none;
    -webkit-border-radius: 0px;
    margin-bottom: 30px;


    border: 1px solid #707070;
    width: 100%;
    height: 170px;
    font-size: 18px;

    &::placeholder {
        color: #999999;
        font-size: 17px;
    }
}

.colorSwatch-checkmark {
    opacity: 0;
    z-index: 5;
    position: relative;
    display: inline-block;    
    width: 17px;
    height: 16px;
    margin-top: 10px;
    margin-right: 8px;
  }
  
  .colorSwatch-checkmark::before {
    position: absolute;
    left: 0;
    top: 50%;
    height: 50%;
    width: 2px;
    background-color: #FFF;
    content: "";
    transform: translateX(10px) rotate(-45deg);
    transform-origin: left bottom;
  }
  
  .colorSwatch-checkmark::after {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 2px;
    width: 100%;
    background-color: #FFF;
    content: "";
    transform: translateX(10px) rotate(-45deg);
    transform-origin: left bottom;
  }
  .colorSwatch {
    display: inline-block;
    margin-right: 20px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid #DBDBDB;
    background-color: #E7E7E7;
    text-align: center;
    position: relative;

    &.c-FFFFFF, &.c-FFF, &.c-ffffff, &.c-fff {
        .colorSwatch-checkmark::before {
          background-color: #000;
        }
    
        .colorSwatch-checkmark::after {
          background-color: #000;
        }
      }
  }
  
  .colorSwatch-color {
    display: inline-block;
    background-color: #FFF;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    text-align: center;
    vertical-align: center;
    line-height: 40px;
  
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
.colorSwatch-color {
    width: 40px;
    height: 40px;
    border: 1px solid #DBDBDB;
}

.colorSwatch-checkmark {
    opacity: 1;
}

.calc-wrap {
    border: 1px solid #BFBFBF;
    padding: 6px 15px;
    text-align: left;
    margin-bottom: 5px;
    height: 60px;

    &.left-half, &.right-half {
        width: 49.5%;
        display: inline-block;
    }

    &.left-half {
        margin-right: 0.5%;
    }

    &.right-half {
        margin-left: 0.5%;
    }

    .calc-label {
        color: #666666;
        font-weight: bold;
        letter-spacing: 1.95px;
        font-size: 12px;
        text-transform: uppercase;
    }

    .calc-input {
        border: 0;
        outline: 0;
        width: 100%;
        font-size: 17px;
        color: #890000;
    }

    .calc-select {
        width: 100%;
        appearance: none;
        border: 0;
        outline: 0;
        color: #890000;

        box-sizing: border-box;
        padding: 0 2rem;
        padding-left: 0;
        -webkit-appearance: none;
        -webkit-border-radius: 0px;

        background: url(${arrow}) no-repeat right #AAA;
        background-size: 24px 10px;
        -webkit-appearance: none;
        background-color: transparent;
        background-position-x: calc( 100% + 0px );
    }
}

.nav-container {
    text-align: center;
}

.calc-coe {
    font-style: italic;
    font-family: MazdaM;
    color: #999999;
    font-size: 15px;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 30px;
}

.calc-red {
    color: #890000;
}

.calc-grey {
    color: #AAA;
}

.nav-wrap {
    display: inline-block;
    margin-top: 19px;
    margin-bottom: 23px;
    
    .nav-txt {
        display: inline-block;
        margin-right: 30px;
        line-height: 20px;
        vertical-align: middle;
        color: #999999;
        font-size: 13px;

        @media (max-width: 420px) {
            margin-right: 15px;
            font-size: 11px;
        }
    }
    .nav-no {
        display: inline-block;
        font-size: 13px;
        color: #FFF;
        background-color: #999999;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 3px;
        line-height: 20px;
    }

    &.active .nav-txt {
        color: #101010;
    }

    &.active .nav-no {
        background-color: #890000;
    }
}

.carTitle-wrap {
    text-align: center;

    .carTitle-class {
        font-size: 25px;
        letter-spacing: 3.75px;
        font-weight: bold;

        @media (max-width: 1000px) {
            display: block;
        }
    }

    .carTitle-label {
        font-size: 15px;
        letter-spacing: 2.25px;
        font-weight: bold;
    }

    .carTitle-demo {
        font-size: 15px;
        letter-spacing: 2.25px;
        font-weight: bold;
    }
}

.wrapper{
    display: block;
    margin: 0 auto;
    height: 100%;
    @media (max-width: 1000px){
        max-width: 450px; 
        height: 100%;
    }
}
.topArtical{
    width: 450px;
    margin: 0 auto;
    @media (max-width: 450px){
        width: 100%;
        padding: 0px 20px;
    }
}
.carTitle {
    // font-family: CorporateACon,Helvetica,sans-serif;
    color: #333333;
    text-align: center;
    font-size: 1.5rem;
    position: relative;
}
.cardetailArtical{
    width: 50%;
    display: block;
    float: left;
    margin-bottom: 100px;
    @media (max-width: 1000px){
        width: 100%;
        margin-bottom: 0px;
    }
}
.cardetailArtical.rightFullScreen{
    float: right;
    margin-top: 10px;
}
.configurator__model_image {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
}
.carImg-info {
    font-family: MazdaM;
    color: #999999;
    font-size: 15px;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
}
.selectText {
    color:rgba(0,0,0,0.7);
    text-align: center;
    font-size: 27px;
    margin-bottom: 0px;
}
.Select-arrow {
    background-image: url(${Down_Arrow});
    background-size: 22.5px 11px;
    width: 22.5px;
    height: 11px;
    background-repeat: no-repeat;
}
.configurator__model-dropdown-container {

    max-width: 450px;
    margin: 0 auto;
    font-family: CorporateACon, Helvetica, sans-serif!important;
    text-align: center;
    display: block;
    height: auto;
    padding: 12px 12px;
    border-top: 1px solid #f3f3f3;
    border-bottom: 1px solid #f3f3f3;
    
    @media(min-width: 450px) {
      width: 450px;
    }
    
    @media(max-width: 450px) {
      width: 100%;
    }
}
.deliver {
    color: rgba(25,25,25,0.5);
    margin-bottom: 30px;
    text-align: center;
    text-transform: uppercase;
}
.installment-bar {

    height: 82.5px;
    padding-top: 12px;
    background-color: grey;
    position: fixed;
    z-index: 10;
    bottom: 0px;
    width: 100%;
    left: 0px;
    text-align: center;
  
  &, &__padding {
    width: 100%;
    height: 82.5px;
  }
  
  &__padding {
    margin-top: 20px;
  }

  .instalment{
    cursor: pointer;
    display: inline-block;
  }
  
  .instalment__amount-value {
      font-size: 25px;
      color: white;
      font-weight: lighter;
      cursor: pointer;
    }
    
    .instalment__amount {
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
    }
  
    .instalment__arrow {
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
      height: 25px;
      width: auto;
      margin: 0 5px;
    }
  
    .instalment__month {
      font-size: 16px;
      color: #eee;
      font-weight: 100;
      cursor: pointer;
    }
  
    .instalment__check-eligibility {
      font-size: 20px;
      color: #ddd;
      font-weight: bold;
      text-align: right;
      cursor: pointer;
    }

}
.boldText {
    color: red;
    font-family: 'CorporateS-Bold';
}
.optinNoticeLink {
    cursor: pointer;
    font-size: 13px;
    color: #890000;
    text-align: left;
    letter-spacing: 1.95px;
    text-transform: uppercase;
    text-decoration: underline;

    @media (min-width: 1000px) {
        text-align: left;
    }

    @media (max-width: 420px) {
        padding-left: 15px;
        padding-right: 15px;
    }
}
.react-datepicker__month-container {
    width: 300px;
}
.react-datepicker__month, .react-datepicker__day-names, .react-datepicker__current-month, .react-datepicker__navigation--previous, .react-datepicker__navigation--next {
    display: block;
}
.carPrice-wrap {
    text-align: center;
    margin-bottom: 30px;

    .carPrice-color {
        font-size: 14px;
    }

    .carPrice-stock {
        color: #890000;
    }
    .carPrice-price {
        font-size: 2.25rem;
        font-family: CorporateACon,Helvetica,sans-serif;
    }
    .carPrice-coe {
        font-size: 1.125rem;
        color: #666666;
    }
}
.imgCaption {
    font-size: 0.8rem;
    color: #BBB;
    margin-top: 10px;
}

.carGallery-wrap {
    .carGallery-image-wrap {
        display: inline-block;
        width: 30%;
        padding-left: 20px;
    }
    .carGallery-image {
        width: 100%;
        padding: 10px 0;
    }
    .carGallery-text {
        vertical-align: top;
        width: 70%;
        font-size: 1rem;
        display: inline-block;
        padding: 10px 20px;
    }
}
.carInfo-title {
    text-align: center;
    font-weight: bold;
    letter-spacing: 3.6px;
    font-size: 24px;
    color: #101010;
}
.carInfo-form {
    background-color: #F8F8F8;
    height: 100%;
}
.carInfo-input-label {
    color: #333333;
    font-size: 14px;
}
.carInfo-input-required {
    color: #ED0F0F;
}
.carInfo-input {
    border: 1px solid #D0D0D0;
    border-radius: 0;
    outline: 0;
    appearance: 0;
    box-sizing: border-box;
    padding: 10px;
    width: 100%;
    height: 48px;
    line-height: 48px;
    color: #333333;
    font-size: 16px;
    margin: 8px 0 2px 0;
    background: none;

    position: relative;

    &.error {
        border: 1px solid #a94442;
    }
}
.carInfo-input-wrap {
    padding: 15px;
    padding-bottom: 0;
    vertical-align: top;
}
.consent-link {
    text-decoration: none;
    color: #890000;
}
.consent-check-container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: inline-block;
  height: 25px;
  width: 25px;
  margin: 0 10px 0 0;
}

.consent-check-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.consent-checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  border: 1px solid #BFBFBF;
}
.consent-check-container input:checked ~ .consent-checkmark {
  background-color: #FFF;
  border: 1px solid #BFBFBF;
}
.consent-checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.consent-check-container input:checked ~ .consent-checkmark:after {
  display: block;
}

.consent-check-container .consent-checkmark:after {
  left: 7px;
  top: 0px;
  width: 9px;
  height: 16px;
  border: solid red;
  border-width: 0 1px 1px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.consent-txt {
    display: inline-block;
    padding-left: 0px;
    vertical-align: top;
    width: calc(100% - 50px);

}
.carInfo-buy {
    display: inline-block;
    background-color: #0F0F0F;
    color: #FFFFFF;
    font-size: 13px;
    font-weight: bold;
    letter-spacing: 1.95px;
    border-radius: 0;
    text-align: center;
    line-height: 60px;
    height: 60px;
    width: 100%;
    margin-bottom: 20px;
    cursor: pointer;
    text-transform: uppercase;

    @media (max-width: 420px) {
        margin-left: 15px;
        margin-right: 15px;
        width: calc(100% - 30px);
    }
}

.carInfo-buy:disabled, .carInfo-enquire:disabled {
    opacity: 0.5;
    cursor: initial;
}
.carInfo-enquire {
    display: inline-block;
    background-color: #000000;
    color: #FFF;
    font-size: 18px;
    border-radius: 0;
    text-align: center;
    line-height: 48px;
    height: 48px;
    width: 100%;
    margin-bottom: 20px;
    cursor: pointer;
}
@media (min-width: 1000px) {
    .topArtical {
        width: 100%;
    }
    .configurator__model_image {
        // width: 690px !important;
    }
    .leftSide {
        padding-left: 135px;
        padding-right: 10px;
        width: 50%;
        display: inline-block;
        float: left;
        // overflow-y: auto;
        // height: calc(90vh - 86px);
        // overflow-x: hidden;
    }
    .rightSide {
        padding-right: 135px;
        width: 50%;
        display: inline-block;
        float: right;
        // overflow-y: auto;
        // height: calc(90vh - 86px);
        padding-left: 15px;
    }
    .cardetailArtical {
        width: 100%;
        float: none;
        margin-bottom: 0;
    }
    .carGallery-feature {
        width: 33%;
        display: inline-block;
        text-align: center;
    }
    .carGallery-image-wrap {
        padding-left: 0 !important;
        width: 100% !important;
    }
    .carGallery-text {
        text-align: left;
        width: 100% !important;
    }
    .carInfo-title {
        padding-left: 0;
    }
    .btnWrap {
        width: 100%;
        display: flex;
        flex-direction: row;
    }
    .carInfo-enquire {
        margin-left: 30px;
        margin-right: 14px;
    }
    .carGallery-image {
        width: 95% !important;
    }
    .carGallery-text {
        padding-left: 6px !important;
    }
    .carInfo-input-wrap.half {
        width: 50%;
        display: inline-block;
    }
}

.carInfo-placeholder::placeholder {
    font-size: 12px;
}

.carInfo-error {
    color: #a94442;
    display: inline-block;

    &.consent {
        font-weight: bold;
        margin-top: 5px;
        margin-bottom: 5px;
    }
}

.carInfo-error-placeholder {
    // height: 1.5rem;
}

.nav-back-button {
    cursor: pointer;
    line-height: 32px !important;
    margin-bottom: 10px;

    @media (max-width: 1000px) {
        padding-left: 15px;
    }
  }    
  
  .nav-back-button img {
    position: relative;
    top: -2px;
  }

  .nav-back-txt {
    padding: 0 7.125px;
    line-height: 30px;
    display: inline-block;
    color: rgba(0,0,0,0.3);
  }
// @media (min-width: 1000px) and (max-width: 1500px) {
//     .leftSide {
//         // margin-top: -20px;
//     }
//     .configurator__model_image {
//         max-height: 150px;
//     }
//     .carPrice-price {
//         font-size: 1.2rem !important;
//     }
//     .modelName {
//         font-size: 1.2rem !important;
//     }
// }
`;

export default withRouter(StyledCustomerInfo)


// WEBPACK FOOTER //
// ./src/components/configurator/CustomerInfo.js